import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { getRestaurant, getIsSavingRestaurant, getErrorRestaurant, getStyles, getTypes, getServices, getIsSavedRestaurant, getPlaces } from './../../reducers';
import FormProfileResto from './../../components/FormProfileResto';
import LoadingPage from './../../components/LoadingPage';
import { setStylesToState } from './../../actions/dataForState/dataForProfile/setStylesToState';
import { setTypesToState } from './../../actions/dataForState/dataForProfile/setTypesToState';
import { setServicesToState } from './../../actions/dataForState/dataForProfile/setServicesToState';
import { setProfileDataToRestaurant, setSavedRestaurant } from './../../actions/setProfileDataToRestaurant';
import ProfileResto from './../../components/ProfileResto';
import { storage } from './../../config/Fire';
import FormImagesResto from '../../components/FormImagesResto';
import { setImagesDataToRestaurant } from '../../actions/setImagesDataToRestaurant';
import { setPlacesToState } from '../../actions/dataForState/dataForProfile/setPlacesToState';

const rangePrice = {
    '$': 'Hasta 100$',
    '$$': 'Hasta 200$',
    '$$$': 'Hasta 300$',
    '$$$$': 'Hasta 500$',
    '$$$$$': 'Mas de 500$'
};

function compareUid( a , b ) {
    if (a.uid < b.uid) {
        return -1
    } else {
        if(a.uid > b.uid) {
            return 1
        } else {
            return 0
        }
    }
}

class Profile extends Component {
    state = {
        isEditingProfile: false,
        isEditingImages: false,
        postalCode: "",
        previewVisibleImageProfile: false,
        previewImageProfile: '',
        fileListProfile: [],
        previewVisibleImageSlider: false,
        previewImageSlider: '',
        fileListSlider: [],
        countriesOptions: [],
        provincesOptions: [],
        citiesOptions: [],
        countrySelected: null,
        provinceSelected: null,
        citySelected: null,
        stateUpdated: false,
        lat: null,
        lng: null
    }

    onSubmitImages = values => {
        this.saveDataImages();
    }

    saveDataImages = () => {
        const { restaurant } = this.props;
        const { fileListProfile, fileListSlider } = this.state;
        
        this.props.setImagesDataToRestaurant({
            id: restaurant.id,
            imageProfile: (fileListProfile && fileListProfile.length > 0) ? fileListProfile[0] : undefined,
            imagesSlider: (fileListSlider && fileListSlider.length > 0) ? fileListSlider : undefined,
        });
    }

    onSubmitProfile = values => {
        this.saveDataProfile(values);
    }

    saveDataProfile = (values) => {
        const { restaurant } = this.props;
        var price;
        if(Array.isArray(values.field_range_price)) {
            price = values.field_range_price[0];
        } else {
            price = values.field_range_price ? values.field_range_price : "";
        }
        this.props.setProfileDataToRestaurant({
            id: restaurant.id,
            name: values.name,
            phone: "+" + values.prefix + values.phone,
            facebook: values.field_facebook ? values.field_facebook : "",
            instagram: values.field_instagram ? values.field_instagram : "",
            website: values.field_web ? values.field_web : "",
            repartiendoDeepLink: values.field_repartiendo ? values.field_repartiendo : "",
            country: values.field_country,
            province: values.field_province,
            city: values.field_city,
            fullAddress: `${values.field_country}/${values.field_province}/${values.field_city}`,
            nearCities: values.field_near_cities ? values.field_near_cities : null,
            neighborhood: values.field_neighborhood ? values.field_neighborhood : "",
            postalCodeV2: values.field_postalCode ? (values.field_postalCode).toString() : "",
            street: values.field_street,
            lat: values.field_lat,
            lng: values.field_lng,
            price: price,
            hitos: values.field_hitos,
            styles: values.field_styles,
            types: values.field_types,
            services: values.field_services,
            accessPeopleWithDisabilities: values.field_accessPeopleWithDisabilities,
            imageProfile: (values.imageProfile && values.imageProfile.fileList.length > 0) ? values.imageProfile.fileList[0] : undefined,
            imagesSlider: (values.imageSlider && values.imageSlider.fileList.length > 0) ? values.imageSlider.fileList : undefined,
        });
    }

    getInfo = () => {
        const { places, styles, types, services } = this.props;
        const { setPlacesToState, setStylesToState, setTypesToState, setServicesToState } = this.props;
        if(!places) {
            setPlacesToState();
        } else {
            if(!styles) {
                setStylesToState();
            } else {
                if(!types) {
                    setTypesToState();
                } else {
                    if(!services) {
                        setServicesToState();
                    } else {
                        if(!this.state.stateUpdated) {
                            this.updateState()
                        }
                    }
                }
            }
        }
        return (<LoadingPage />);
    }

    isInfoLoaded = () => {
        const { places, styles, types, services } = this.props;
        if(places && styles && types && services) {
            return true;
        } else {
            return false;
        }
    }

    onEditProfile = () => {
        this.setState({ isEditingProfile: true, isEditingImages: false });
        this.initialDataProfile();
    }

    onEditImages = () => {
        this.setState({ isEditingImages: true, isEditingProfile: false });
        this.initialDataImages();
    }

    handleChangeCity = value => {
        this.setState({ postalCode: this.props.cities[value] ? this.props.cities[value].postalCode ? this.props.cities[value].postalCode : "" : "" });
    }
    
    handleExitEdition = () => {
        this.setState({ isEditingProfile: false, isEditingImages: false });
    }

    //Images

    getBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        });
    }

    beforeUpload(file) {
        return new Promise((resolve, reject) => {
        setTimeout(() => {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            if (isJPG || isPNG) {
                if(file.size > (1024*1024)) { //size max 1MB
                    message.error('El tamaño máximo de la imagen es de 1MB');
                    reject(file);
                } else {
                    resolve(file);
                }
            } else {
                message.error('Solo puedes cargar archivos .jpeg o .png!');
                reject(file);
            }
        }, 0);
        });
    }

    handleCancelImageProfile = () => this.setState({ previewVisibleImageProfile: false });

    handlePreviewImageProfile = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }

        this.setState({
            previewImageProfile: file.url || file.preview,
            previewVisibleImageProfile: true,
        });
    };

    handleChangeImageProfile = ({ fileList }) => this.setState({ fileListProfile: fileList });

    handleCancelImageSlider = () => this.setState({ previewVisibleImageSlider: false });

    handlePreviewImageSlider = async file => {
        if (!file.url && !file.preview) {
            file.preview = await this.getBase64(file.originFileObj);
        }

        this.setState({
        previewImageSlider: file.url || file.preview,
        previewVisibleImageSlider: true,
        });
    };

    handleChangeImageSlider = ({ fileList }) => this.setState({ fileListSlider: fileList });

    renderSavedRestaurant = () => {
        message.success('¡Los cambios se guardaron exitósamente!');
        var isSavedRestaurant = false;
        this.props.setSavedRestaurant(isSavedRestaurant);
        this.setState({ isEditingProfile: false, isEditingImages: false });
        return;
    }

    onLatChange = e => {
        this.setState({ lat: e.target.value });
    }

    onLngChange = e => {
        this.setState({ lng: e.target.value });
    }

    initialDataProfile = () => {
        if(this.props.restaurant && this.props.restaurant.l) {
            this.setState({ lat: this.props.restaurant.l[0], lng: this.props.restaurant.l[1] })
        }
    }

    initialDataImages = () => {
        if(this.props.restaurant) {
            var imagesSlider = [];
            var imagesProfile = [];
            var promisesGetImagesStorage = [];
            var promisesGetProfileImageStorage = [];
            if(this.props.restaurant.media && Array.isArray(this.props.restaurant.media)) {
                this.props.restaurant.media.forEach((element, index) => {
                    //let uri = element.url.split('/').join('%2F');
                    var storageSlider = storage.ref().child(element.url).getDownloadURL().then(url => {
                        imagesSlider.push({ uid: index, name: index, status: 'done', url: url });
                    });
                    promisesGetProfileImageStorage.push(storageSlider)
                });
            }
            return Promise.all(promisesGetProfileImageStorage)
            .then(() => {
                if(this.props.restaurant.logo && this.props.restaurant.logo !== "") {
                    var storageProfile = storage.ref().child(this.props.restaurant.logo).getDownloadURL().then(url => {
                        imagesProfile.push({ uid: 0, name: "0", status: 'done', url: url });
                    });
                    promisesGetImagesStorage.push(storageProfile)
                }
                return Promise.all(promisesGetImagesStorage)
                .then(() => {
                    imagesSlider.sort(compareUid)
                    this.setState(function(prevState, props) {
                        return { fileListProfile: imagesProfile, fileListSlider: imagesSlider }
                    })
                })
                .catch(() => {
                    this.setState(function(prevState, props) {
                        return { fileListProfile: imagesProfile, fileListSlider: imagesSlider }
                    })
                })
            })
            .catch(() => {
                return Promise.all(promisesGetImagesStorage)
                .then(() => {
                    imagesSlider.sort(compareUid)
                    this.setState(function(prevState, props) {
                        return { fileListProfile: imagesProfile, fileListSlider: imagesSlider }
                    })
                })
                .catch(() => {
                    this.setState(function(prevState, props) {
                        return { fileListProfile: imagesProfile, fileListSlider: imagesSlider }
                    })
                })
            })
        } else {
            this.setState(function(prevState, props) {
                return { fileListProfile: [], fileListSlider: [] }
            })
        }
    }

    handleDeepLinkClick = () => {
        if(this.props.restaurant && this.props.restaurant.deepLink) {
            var deepLink = this.props.restaurant.deepLink;
            navigator.clipboard.writeText(deepLink);
            message.success('¡Link copiado!');
        }
    }

    handleRepartiendoDeepLinkClick = () => {
        if(this.props.restaurant && this.props.restaurant.repartiendoDeepLink) {
            var deepLink = this.props.restaurant.repartiendoDeepLink;
            navigator.clipboard.writeText(deepLink);
            message.success('¡Link Repartiendo copiado!');
        }
    }

    getProvincesByCountry = country => {
        const { places } = this.props;
        var provinces = [];
        if(places && places[country]) {
            places[country]['provinces'].forEach(province => {
                if(province && province.name) {
                    provinces.push(province.name);
                }
            });
        }
        this.setState({ provincesOptions: provinces, countrySelected: country })
    }

    getCitiesByProvince = provinceSelected => {
        const { places, restaurant } = this.props;
        const { countrySelected } = this.state;
        var cities = [];
        var country = null;
        if(!countrySelected) {
            country = (restaurant.address && restaurant.address.country) ? restaurant.address.country : null
        } else {
            country = countrySelected;
        }
        if(country) {
            places[country]['provinces'].forEach(province => {
                if(province && province.name === provinceSelected && province.cities) {
                    province.cities.forEach(city => {
                        if(city && city.name) {
                            cities.push(city.name);
                        }
                    });
                }
            });
            this.setState({ citiesOptions: cities, provinceSelected: provinceSelected })
        }
    }

    getDataByCity = citySelected => {
        const { places, restaurant } = this.props;
        const { countrySelected, provinceSelected } = this.state;
        var city = null;
        var country = null;
        var province = null;
        if(!countrySelected) {
            country = (restaurant.address && restaurant.address.country) ? restaurant.address.country : null
        } else {
            country = countrySelected;
        }
        if(!provinceSelected) {
            province = (restaurant.address && restaurant.address.province) ? restaurant.address.province : null
        } else {
            province = provinceSelected;
        }
        if(country && province) {
            places[country]['provinces'].forEach(provinceLoop => {
                if(provinceLoop && provinceLoop.name === province && provinceLoop.cities) {
                    provinceLoop.cities.forEach(cityVal => {
                        if(cityVal && cityVal.name && cityVal.name === citySelected) {
                            city = cityVal;
                        }
                    });
                }
            });
            if(city) {
                this.setState({ citySelected: city })
            }
        }
    }

    updateState = () => {
        if(this.props.restaurant.address && this.props.restaurant.address.country) {
            this.getProvincesByCountry(this.props.restaurant.address.country)
        }
        if(this.props.restaurant.address && this.props.restaurant.address.province) {
            this.getCitiesByProvince(this.props.restaurant.address.province)
        }
        if(this.props.restaurant.address && this.props.restaurant.address.city) {
            this.getDataByCity(this.props.restaurant.address.city)
        }
        this.setState({ stateUpdated: true })
    }

    getImageProfile = () => {
        if(this.props.restaurant.logo && this.props.restaurant.logo !== "") {
            var imagesProfile = [];
            storage.ref().child(this.props.restaurant.logo).getDownloadURL().then(url => {
                imagesProfile.push({ uid: - 1, name: "0", status: 'done', url: url });
                this.setState({ fileListProfile: imagesProfile });
            });
        }
    }

    render() {
        const { restaurant, places, styles, types, services, isSavedRestaurant } = this.props;
        const { provincesOptions, citiesOptions, citySelected, provinceSelected, countrySelected } = this.state;
        return (
            <div>
                {
                    restaurant ?
                        <div>
                            {
                                this.state.isEditingProfile ?
                                    this.isInfoLoaded() && this.state.stateUpdated ?
                                        <div>
                                            <FormProfileResto restaurant={restaurant} citySelected={citySelected} onSubmit={this.onSubmitProfile} 
                                            countriesOptions={places ? Object.keys(places) : []} provincesOptions={provincesOptions} onCountrySelected={this.getProvincesByCountry}
                                            onProvinceSelected={this.getCitiesByProvince} citiesOptions={citiesOptions}
                                            countrySelected={countrySelected} provinceSelected={provinceSelected}
                                            onCitySelected={this.getDataByCity} isSaving={this.props.isSavingRestaurant} onExit={this.handleExitEdition}
                                            places={places} styles={styles} types={types} services={services} rangePrice={rangePrice} 
                                            lat={this.state.lat} lng={this.state.lng} onLatChange={this.onLatChange} onLngChange={this.onLngChange} />
                                        </div>
                                        :
                                        this.getInfo()
                                    :
                                    this.state.isEditingImages ?
                                        <FormImagesResto
                                        onSubmit={this.onSubmitImages}
                                        isSaving={this.props.isSavingRestaurant} onExit={this.handleExitEdition}
                                        beforeUpload={this.beforeUpload}
                                        handleCancelImageProfile={this.handleCancelImageProfile} handlePreviewImageProfile={this.handlePreviewImageProfile} handleChangeImageProfile={this.handleChangeImageProfile} fileListProfile={this.state.fileListProfile} previewImageProfile={this.state.previewImageProfile} previewVisibleImageProfile={this.state.previewVisibleImageProfile}
                                        handleCancelImageSlider={this.handleCancelImageSlider} handlePreviewImageSlider={this.handlePreviewImageSlider} handleChangeImageSlider={this.handleChangeImageSlider} fileListSlider={this.state.fileListSlider} previewImageSlider={this.state.previewImageSlider} previewVisibleImageSlider={this.state.previewVisibleImageSlider}
                                        />
                                        :
                                        <div>
                                            {this.getImageProfile()}
                                            <ProfileResto onRepartiendoDeepLinkClick={this.handleRepartiendoDeepLinkClick} restaurant={restaurant} onDeepLinkClick={this.handleDeepLinkClick} fileListProfile={this.state.fileListProfile} onEditProfile={this.onEditProfile} onEditImages={this.onEditImages} rangePrice={rangePrice}/>
                                        </div>
                            }
                            {
                                isSavedRestaurant && this.renderSavedRestaurant()
                            }
                        </div>
                        :
                        <LoadingPage />
                }
            </div>
        );
    }
}

Profile.propTypes = {
    restaurant: PropTypes.object,
    places: PropTypes.object,
    hitos: PropTypes.array,
    cities: PropTypes.object,
    countries: PropTypes.object,
    neighborhoods: PropTypes.object,
    provinces: PropTypes.object,
    services: PropTypes.object,
    isSavingRestaurant: PropTypes.bool.isRequired,
    isSavedRestaurant: PropTypes.bool.isRequired,
    errorRestaurant: PropTypes.object.isRequired,
};

const mapDispatchToPropsActions = dispatch => ({
    setPlacesToState: value => dispatch(setPlacesToState(value)),
    setStylesToState: value => dispatch(setStylesToState(value)),
    setTypesToState: value => dispatch(setTypesToState(value)),
    setServicesToState: value => dispatch(setServicesToState(value)),
    setProfileDataToRestaurant: value => dispatch(setProfileDataToRestaurant(value)),
    setImagesDataToRestaurant: value => dispatch(setImagesDataToRestaurant(value)),
    setSavedRestaurant: value => dispatch(setSavedRestaurant(value)),
});

const mapStateToProps = state => ({
    restaurant:  getRestaurant(state),
    places: getPlaces(state),
    styles: getStyles(state),
    types: getTypes(state),
    services: getServices(state),
    isSavingRestaurant: getIsSavingRestaurant(state),
    isSavedRestaurant: getIsSavedRestaurant(state),
    errorRestaurant: getErrorRestaurant(state),
});

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(Profile));